import axios from 'axios'

import { addDays, formatDate } from '@/helpers/date'
import {
    LeaveOfAbsenceResource,
    LeaveOfAbsenceViewModel,
} from '@/models'
import { transformLeaveOfAbsenceResource } from '@/services/LeaveOfAbsenceService/transformLeaveOfAbsenceResource'
import { DateFormat } from '@/types'

interface GetLeaveOfAbsencesParams {
    userId: string
    startDate: Date | null
    endDate: Date | null
    status: LeaveOfAbsenceStatusNumber[]
    includes?: string[]
}

export type LeaveOfAbsenceStatusNumber = 1 | 2 | 3

export const getLeaveOfAbsences = async (
    params: GetLeaveOfAbsencesParams,
): Promise<LeaveOfAbsenceViewModel[]> => {
    const {
        userId,
        startDate,
        endDate,
        status,
        includes = [],
    } = params
    const newStartDate = (startDate && endDate) ? formatDate(startDate, DateFormat.apiDateTime) : formatDate(addDays(new Date(), -1), DateFormat.apiDateTime)

    const response = await axios.get<LeaveOfAbsenceResource[]>(
        `${process.env.REACT_APP_API_URL}/leave-of-absences/me`,
        {
            params: {
                include: includes.join(','),
                startDate: newStartDate,
                endDate: endDate && formatDate(endDate, DateFormat.apiDateTime),
                statuses: JSON.stringify(status),
                userUuids: JSON.stringify([userId]),
            },
        },
    )

    return response.data.map(resource => transformLeaveOfAbsenceResource(
        resource,
        resource.leaveOfAbsenceHours,
    ))
}